import { Box, Grid } from '@mui/material';

import SettingsHeader from '../../components/SettingsHeader/SettingsHeader';
import { WsBreadCrumbs } from '../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../teams/helper/defaultValues';

import NativeSearchIndex from './components/nativeSearchIndex/NativeSearchIndex';

interface IJobBoard {
  children: React.ReactElement;
}

const NativeSearchSettings = ({ children }: IJobBoard) => (
  <Box borderRadius={1.5}>
    <WsBreadCrumbs
      breadCrumbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.APPS_AND_INTEGRATION,
        Pages['NATIVE_SEARCH_CONFIGURATION']
      )}
    />
    <SettingsHeader title={'Native Search Configuration'} />
    <Grid marginTop={2} spacing={1} container>
      <Grid item xs={3}>
        <NativeSearchIndex />
      </Grid>
      <Grid item xs={9}>
        {children}
      </Grid>
    </Grid>
  </Box>
);

export default NativeSearchSettings;
